import React from 'react';

export default ({
	number = null, 
	ext = null
})=>{
	const formatted = number ? number.replace(/(\d\d\d)(\d\d\d)(\d\d\d\d)/, '$1-$2-$3') : null;
	return <span>{formatted}{ext ? ' x'+ext : null}</span>;
};